/**
 * The "Add item" marker for the admin menu catalogue.
 *
 * Both consoles keep one `editingItem` state that doubles as "is the dialog open".
 * They used to open the Add dialog with `{}`, which is truthy — and MenuItemDialog
 * reads a truthy `item` as "edit this one", so the dialog titled itself "Edit
 * undefined" and its save threw on `form.name.trim()`. Identity against this
 * constant is what separates "adding" from "editing", and it lives here rather than
 * in either page so the phone console does not have to import the desktop one.
 */
export const NEW_ITEM = Object.freeze({ __new: true });
